import { Injectable } from '@angular/core';
import { AppConfiguration, ClientEnviroment } from 'src/app/models/Security.User';
import { CLIENT_STYLES } from 'src/app/shared/constants/client-styles.constants';
import { UtilsService } from 'src/app/utils/utils.service';

@Injectable({
    providedIn: 'root'
})
export class ConfigurationService  {

    private configuration: AppConfiguration;

    constructor(private readonly utilsService: UtilsService) {
        //this.getConfiguration();
    }

    async setInitialConfgiguration() {
        const user = await this.utilsService.getCookieUser();
        const styleValue = CLIENT_STYLES.get(user.email) ?? ClientEnviroment.Experian;
        this.configuration = JSON.parse(`{"clientEnviroment" : ${styleValue} ,"documentationPacks" : [ {"packName": "AUTFIN01", "packDescription":"Pack Base"}],"availableQueries": { "requestors": {"physicalPerson":true, "legalEntity": false},"requests": { "clavePin": false, "clavePinWithSMS": true, "SMS": false, "videoId": false, "knownClient": false} }}`);
        sessionStorage.setItem('currentUser', "{ \"loginName\": \"" + user.name + "\", \"appConfiguration\": {\"clientEnvironment\" : \"Sabadell\",\"documentationPacks\" : [ {\"packName\": \"AUTFIN01\", \"packDescription\":\"Pack Base\"}],\"availableQueries\": { \"requestors\": {\"physicalPerson\":true, \"legalEntity\": false},\"requests\": { \"clavePin\": false, \"clavePinWithSMS\": true, \"SMS\": false, \"videoId\": false, \"knownClient\": false} }}  }");
    }

    // getConfiguration() {
    //     //if (this.configuration == null) {
    //     //this.configuration = this.authenticationService.currentUserValue.appConfiguration;
    //     // const userEmail = sessionStorage.getItem('od-web-user-email');
    //     const userEmail = this.authenticationService.currentCookieUserValue.email;

    //     const styleValue = CLIENT_STYLES.get(userEmail) ?? ClientEnviroment.Experian;

    //     this.configuration = JSON.parse(`{"clientEnviroment" : ${styleValue} ,"documentationPacks" : [ {"packName": "AUTFIN01", "packDescription":"Pack Base"}],"availableQueries": { "requestors": {"physicalPerson":true, "legalEntity": false},"requests": { "clavePin": false, "clavePinWithSMS": true, "SMS": false, "videoId": false, "knownClient": false} }}`);
    //     return this.configuration;
    // }

    getConfiguration() {
        return this.configuration;
    }

    setConfiguration(conf: AppConfiguration): void {
        this.configuration = conf;
    }

    setStyle(): void {
        switch (this.configuration.clientEnviroment) {
            case ClientEnviroment.Santander:
                this.loadStyle('assets/css/client/santander.css');
                break;
            case ClientEnviroment.Sabadell:
                this.loadStyle('assets/css/client/sabadell.css');
                break;
            case ClientEnviroment.Unicaja:
                this.loadStyle('assets/css/client/unicaja.css');
                break;
            case ClientEnviroment.Experian:
                this.loadStyle('assets/css/client/experian.css');
                break;
        }
    }

    setDefaultStyle(): void {
        this.loadStyle('assets/css/client/experian.css');
    }

    loadStyle(styleName: string): void {
        const head = document.getElementsByTagName('head')[0];
        const existingLink = document.getElementById('app-theme') as HTMLLinkElement;

        if (existingLink) {
            existingLink.href = styleName;
        } else {
            const newLink = document.createElement('link');
            newLink.id = 'app-theme';
            newLink.rel = 'stylesheet';
            newLink.href = styleName;
            head.appendChild(newLink);
        }
    }
}
